/* eslint-disable no-undef */
import html5 from "../../assets/technologies/html.svg";
import css3 from "../../assets/technologies/css.svg";
import javascript from "../../assets/technologies/javascript.svg";
import reactjs from "../../assets/technologies/react.svg";
import styledComponents from "../../assets/technologies/styled-components.svg";
import bootstrap from "../../assets/technologies/bootstrap.svg";
import node from '../../assets/technologies/nodejs-2.svg'
import npm from "../../assets/technologies/npm.svg";
import git from "../../assets/technologies/git.svg";
import github from "../../assets/technologies/github.svg";
import mongo from '../../assets/technologies/mongodb-icon-1.svg'
import typescript from '../../assets/technologies/typescript-2.svg'
import vscode from "../../assets/technologies/visual-studio-code.svg";
import heroku from '../../assets/technologies/heroku-4.svg'

export const iconsData = [
  {
    id: 1,
    icon: html5,
    name: "HTML5",
  },
  {
    id: 2,
    icon: css3,
    name: "CSS3",
  },
  {
    id: 3,
    icon: javascript,
    name: "JavaScript",
  },
  {
    id: 4,
    icon: reactjs,
    name: "React JS",
  },
  {
    id: 5,
    icon: styledComponents,
    name: "Styled Components",
  },
  {
    id: 6,
    icon: typescript,
    name: "Typescript",
  },
  {
    id: 7,
    icon: bootstrap,
    name: "Bootstrap",
  },
  {
    id: 8,
    icon: mongo,
    name: "MongoDB",
  },
  {
    id: 9,
    icon: npm,
    name: "Node Package Manager",
  },
  {
    id: 10,
    icon: heroku,
    name: 'Heroku'
  },
  {
    id: 11,
    icon: git,
    name: "Git",
  },
  {
    id: 12,
    icon: github,
    name: "GitHub",
  },
  {
    id: 13,
    icon: node,
    name: "NodeJs",
  },
  {
    id: 14,
    icon: vscode,
    name: "Visual Studio Code",
  },
];
